<template>
  <div class="smart-points">
    <!-- Transporter with Smart Point default map / selection  -->
    <SmartPointDefault
      v-if="shouldDisplayDefault"
      :transporter="transporter"
    />

    <!-- Transporter with Smart Point widget / selection  -->
    <SmartPointWidget
      v-if="shouldDisplayWidget"
      :transporter="transporter"
    />
  </div>
</template>

<script>
import SmartPointWidget from './Widgets/SmartPointWidget.vue'
import SmartPointDefault from './SmartPointDefault.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SmartPoints',
  components: { SmartPointWidget, SmartPointDefault },
  props: {
    transporter: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getTransporters',
      'getSelectedTransporterSmartPointEnable',
      'getSelectedTransporterObject'
    ]),
    shouldDisplayDefault () {
      return this.getSelectedTransporterSmartPointEnable &&
        this.getSelectedTransporterObject &&
        !this.getSelectedTransporterObject.useTransporterWidget
    },
    shouldDisplayWidget () {
      return this.getSelectedTransporterSmartPointEnable &&
        this.getSelectedTransporterObject &&
        this.getSelectedTransporterObject.useTransporterWidget
    }
  }
}
</script>
